import { render, staticRenderFns } from "./sdk_file.vue?vue&type=template&id=4d998da0&scoped=true&"
import script from "./sdk_file.vue?vue&type=script&lang=js&"
export * from "./sdk_file.vue?vue&type=script&lang=js&"
import style0 from "./sdk_file.vue?vue&type=style&index=0&id=4d998da0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d998da0",
  null
  
)

export default component.exports